import { AuthorRoles, IChatMessage } from '../../../libs/models/ChatMessage';

/**
 * The user's question a Spiris sign-in/activation card can resend. It is not always the message right
 * before the card: a card from a resumed approval follows the approval's own bot message.
 */
export const lastUserMessageBefore = (messages: IChatMessage[], index: number): string | undefined =>
    messages
        .slice(0, index)
        .reverse()
        .find((message) => message.authorRole === AuthorRoles.User)?.content;
